import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ModuleHelp from "@/components/help/ModuleHelp";

export default function Auditoria() {
  const [logs, setLogs] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/audit-logs").then((r) => setLogs(r.data)).catch((e) => setErr(e.message));
  }, []);

  return (
    <div className="space-y-4" data-testid="auditoria-page">
      <div>
        <div className="label-mil text-[var(--gold)]">Rastreabilidade</div>
        <h1 className="font-display text-3xl font-bold mt-1 flex items-center gap-3">Histórico de Auditoria <ModuleHelp module="auditoria" /></h1>
        <p className="text-[var(--text-muted)] text-sm mt-2">
          {logs.length} eventos registrados.
        </p>
      </div>
      {err && <div className="text-sm text-[var(--danger)]">{err}</div>}

      <div className="card-mil overflow-hidden">
        <table className="w-full text-sm" data-testid="auditoria-table">
          <thead>
            <tr>
              {["Quando", "Usuário", "Ação", "Entidade", "ID", "IP"].map((h) => (
                <th key={h} className="px-4 py-3 label-mil border-b border-[var(--border)] text-left">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.log_id} className="border-b border-[var(--border)]/50 hover:bg-[var(--surface-2)]">
                <td className="px-4 py-3 font-mono text-[10px] text-[var(--text-muted)]">
                  {l.data_hora ? new Date(l.data_hora).toLocaleString("pt-BR") : "—"}
                </td>
                <td className="px-4 py-3 text-sm">{l.usuario_nome || "—"}</td>
                <td className="px-4 py-3"><span className="badge badge-info">{l.acao}</span></td>
                <td className="px-4 py-3 text-xs">{l.entidade}</td>
                <td className="px-4 py-3 font-mono text-[10px] text-[var(--text-muted)] truncate max-w-[140px]">{l.entidade_id || "—"}</td>
                <td className="px-4 py-3 font-mono text-[10px] text-[var(--text-muted)]">{l.ip || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
